import { Component, Inject, Input } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { ApiClientConstant, ApiConnector, Table } from '@cureskin/api-client';
import { SalesService } from '../../../services/sales.service';
import { AddressBookModule } from '../../../../order/edit/address-book-selection/address-book.module';
import { ConnectionService } from '../../../../../services/connection-service';


@Component({
  selector: 'address-confirmation-modal',
  templateUrl: './address-confirmation-modal.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, AddressBookModule, MatDialogContent],
})

export class AddressConfirmationModalComponent {
  // @Input() type: string = '';
  // @Input() user: Table.User;
  parseObject: Table.Order;
  regimen: Array<Table.Regimen> = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private salesService: SalesService,
    private conn: ConnectionService,
    private dialogRef: MatDialogRef<AddressConfirmationModalComponent>,
  ) { }

  async ngOnInit(): Promise<void> {
    this.parseObject = new Table.Order();
    this.parseObject.set('user', this.data.user);
    await this.getRegimens(this.data.type);
  }

  async onProceed(): Promise<void> {
    const productsList: Array<string> = [];
    const servicesList: Array<string> = [];
    const OrderData = {
      addressBookId: this.parseObject.get('addressBook').id,
      paymentType: this.parseObject.get('paymentType') || ApiClientConstant.Order.PaymentType.NOT_SELECTED,
      regimenId: this.regimen[0].get('regimenId'),
      type: ApiClientConstant.Order.Type.REGIMEN,
      uniqueId: uuid(),
      userObjectId: this.parseObject.get('user').id,
      products: productsList?.join(',') || '',
      services: servicesList?.join(',') || '',
    }
    try {
      this.parseObject = await ApiConnector.cloudRun('checkoutAndCreateOrder', OrderData);
      this.dialogRef.close({ type: this.data.type });
    } catch (error) {
      console.log(error);
      // this.broadcaster.broadcast('NOTIFY', { message: error.message, type: 'ERROR' });
    }
    // this.salesService.emitEvent({ event: 'orderCreated', parseObject: this.parseObject, type: this.data.type });
  }

  hideModal(): void {
    this.dialogRef.close();
  }

  async getRegimens(type: string): Promise<void> {
    const regimens = await this.conn.findRegimens({
      where: { forUser: this.data.user, class: type },
      include: ['concernsLanguageString', 'night.product' as 'night', 'morning.product' as 'morning',
        'variants.products' as 'variants',
        'variants.regimen.products.product.title' as 'variants'],
      project: ['regimenId',
        'title', 'active', 'class', 'variants', 'fixedPrice'],
    });
    this.regimen = regimens;
  }
}
